import axios from '../plugins/axios';

const API_URL = '/admin/payments';

export default {
  async getPayments(filters = {}) {
    try {
      console.log('Fetching payments with filters:', filters);
      let url = API_URL;
      
      // Special handling for room booking payments
      if (Object.keys(filters).length > 0) {
        let queryParams = [];
        
        // If we have paymentable_id and type is 'room', use the specific format for room bookings
        if (filters.paymentable_id && filters.type === 'room') {
          queryParams = [
            '_filters_[]=paymentable_id',
            '_filters_[]=paymentable_type',
            `paymentable_type=App\\Models\\RoomBooking`,
            '_no_pagination_=1',
            `paymentable_id=${filters.paymentable_id}`
          ];
        } 
        // If we have paymentable_id and type is 'course', use the specific format for course bookings
        else if (filters.paymentable_id && filters.type === 'course') {
          queryParams = [
            '_filters_[]=paymentable_id',
            '_filters_[]=paymentable_type',
            `paymentable_type=App\\Models\\CourseReservation`,
            '_no_pagination_=1',
            `paymentable_id=${filters.paymentable_id}`
          ];
        }
        // If we have bookingId and paymentable_type is 'App\\Models\\SpaceBooking', use the specific format for space bookings
        else if (filters.bookingId && filters.paymentable_type === 'App\\Models\\SpaceBooking') {
          queryParams = [
            '_filters_[]=paymentable_id',
            '_filters_[]=paymentable_type',
            `paymentable_type=App\\Models\\SpaceBooking`,
            '_no_pagination_=1',
            `paymentable_id=${filters.bookingId}`
          ];
        }
        // Otherwise, use the generic format
        else {
          for (const key in filters) {
            queryParams.push(`${key}=${encodeURIComponent(filters[key])}`);
          }
        }
        
        url += `?${queryParams.join('&')}`;
      }
      
      console.log('Payment API URL:', url);
      const response = await axios.get(url);
      console.log('Payment API response:', response.data);
      
      // Handle the specific response format for payments
      if (response.data && response.data.success && response.data.data) {
        // Return the data array directly
        return { data: response.data.data };
      }
      
      // Ensure data.data is an array
      if (response.data && response.data.data && !Array.isArray(response.data.data)) {
        console.warn('API returned non-array data:', response.data);
        response.data.data = response.data.data || [];
      }
      
      // Handle the case where the response is directly an array (no pagination)
      if (Array.isArray(response.data)) {
        return { data: response.data };
      }
      
      return response;
    } catch (error) {
      console.error('Error fetching payments:', error);
      throw error;
    }
  },

  async createPayment(data) {
    try {
      const paymentData = { ...data };
      
      // Ensure amount is a number
      if (paymentData.amount) {
        paymentData.amount = parseFloat(paymentData.amount);
      }
      
      console.log('Creating payment with data:', paymentData);
      const response = await axios.post(API_URL, paymentData);
      return response.data;
    } catch (error) {
      console.error('Error creating payment:', error);
      throw error;
    }
  },

  async updatePayment(id, data) {
    try {
      // Ensure amount is a number
      if (data.amount) {
        data.amount = parseFloat(data.amount);
      }
      
      const response = await axios.put(`${API_URL}/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating payment:', error);
      throw error;
    }
  },

  async deletePayment(id) {
    try {
      const response = await axios.delete(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting payment:', error);
      throw error;
    }
  },

  async getPaymentById(id) {
    try {
      const response = await axios.get(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching payment:', error);
      throw error;
    }
  },

  async printReceipt(id) {
    try {
      const response = await axios.get(`${API_URL}/${id}/receipt`, {
        responseType: 'blob'
      });
      return response;
    } catch (error) {
      console.error('Error printing receipt:', error);
      throw error;
    }
  }
}; 